import gsap from "gsap";
import { Component, NgZone, OnDestroy, OnInit,HostListener } from '@angular/core';
import { AppstorageTsService } from 'src/app/services/appstorage/appstorage.ts.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { EventsService } from 'src/app/services/event/event.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { NavParams, Platform } from '@ionic/angular';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { BehaviorSubject, Subject,combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OverlayService } from 'src/app/services/overlay/overlay.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { HttpClient } from '@angular/common/http';
import { AdvertisingId } from "@capacitor-community/advertising-id";
import { GalleryService } from "src/app/services/gallery/gallery.service";
import { PreloaderService} from "src/app/services/preloader/preloader.service"
import { AudioService } from "src/app/services/audio/audio.service";
import { PlatformResponse } from "src/app/interfaces/webservices-interface";
import { LoginService } from "src/app/services/login/login.service";
import { TrackConsentService } from "src/app/services/tracking-consent/track-consent.service";
import { NotificationHandlerService } from "src/app/services/notification-handler/notification-handler.service";
declare var window: any;
declare var cordova: any;

@Component({
  selector: 'app-launch-check',
  templateUrl: './launch-check.component.html',
  styleUrls: ['./launch-check.component.scss'],
})
export class LaunchCheckComponent implements OnInit, OnDestroy {

  private loadingFinished: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private permissionGranted: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private ngUnsubscribe = new Subject<void>();
  private bgImageName;

  generatedCSRF;
  platformID;
  ATIDeviceID;
  ATIDeviceIDFound: boolean = null;
  checkSessionResponse: boolean = false;
  percentage = 0;
  displayText = 'Loading...'.toUpperCase();
  hidePercentage = false;
  showOverlay = false;
  locationSettingsReCheck: boolean = false;
  shouldRestrictPlayer: boolean = null;
  androidIpGeoCheck=true;
  permissionTimeout;
  loadingSteps = {
    '21': 'Having a Candy Blast...',
    '41': 'Tending the Pixie Garden...',
    '61': 'Relaxing on Jackpot Shores...',
    '81': 'Collecting Boyd Rewards...',
  };

  constructor(
    private appStorageService: AppstorageTsService,
    private authenticationService: AuthenticationService,
    private eventService: EventsService,
    private userSessionService: UserSessionService,
    private platform: Platform,
    private navigator: Navigator,
    private loginService: LoginService,
    private navParams: NavParams,
    private http: HttpClient,
    private configService: ConfigService,
    private overlay: OverlayService,
    private galleryService:GalleryService,
    private preloader:PreloaderService,
    private audioService:AudioService,
    private zone: NgZone,
    private trackService:TrackConsentService,
    private notificationHandler: NotificationHandlerService
  ) {
    if (this.platform.is('capacitor')) {
      if (window.cordova && window.cordova.plugins && window.cordova.plugins.BoydMigrationAti) {
        cordova.plugins.BoydMigrationAti.fetchGuestKey(success => {
          if ("undefined" === typeof success || "undefined" === typeof success.source || success.source == "none") {
            console.log("MIGRATION-ATI: no guest key found");
          } else {
            console.log("MIGRATION-ATI: success: " + JSON.stringify(success));
            const foundMigrationData = JSON.stringify(success)
            const parsedData = JSON.parse(foundMigrationData);
            console.log(parsedData)
            //ios or android will have different key value
            if (this.platform.is('ios')) {
              if (parsedData.device_id) {
                this.ATIDeviceID = parsedData.device_id;
                this.ATIDeviceIDFound = true;
              }
            }

            if (this.platform.is('android')) {
              if (parsedData.platform_account_id) {
                this.ATIDeviceID = parsedData.platform_account_id;
                this.ATIDeviceIDFound = true;
              }
            }
          }
        }, error => {
          console.error('MIGRATION-ATI: error: ', JSON.stringify(error, null, 4));
        });
      }
    } else {
      this.ATIDeviceIDFound = false;
    }

    //Location not enabled and then player enabled the location case to properly remove splash screen
    this.locationSettingsReCheck = navParams.data.locationSettingCall ? navParams.data.locationSettingCall : false;
    if (!this.platform.is('capacitor') || this.locationSettingsReCheck) this.checkForLocalHost();
  }

  async ngOnInit() {
    this.updateBackgroundImage();
    this.permissionTimeout =
      this.configService.getConfig().FEATURE_TRACKING_TIMEOUT ?? 15000;
     this.androidIpGeoCheck = this.configService.getConfig()?.FEATURE_ANDROID_IPGEOCHECK == 'true' || false;

    this.galleryService.getGameList();
    this.audioService.loadAudio();
    if (this.platform.is("capacitor")) {

      this.updateLoaderPercent();
      if (this.platform.is("android")) {
        setTimeout(() => this.checkAppTrackingPermission(), this.permissionTimeout);
        if (this.androidIpGeoCheck) {
            this.appCheckUserGeoBasedOffWebserviceCall();
        } else {
            this.appLaunchLogicCheck();
        }
      } else if (this.platform.is('ios')) {
       const isTrackConsentConfigAllowed = this.trackService.checkTrackConsentConfigAllowed();
       if(!isTrackConsentConfigAllowed){
        setTimeout(() => this.checkAppTrackingPermission(), this.permissionTimeout);
       }
        this.appLaunchLogicCheck();
      }


    } else {
      this.updateLoaderPercent();
      this.appCheckUserGeoBasedOffWebserviceCall();
    }
  }

  private checkForLocalHost(): any {
    const currentUrl = window.location.href;
    const parsedUrl = new URL(currentUrl);
    if (parsedUrl.hostname === 'localhost') {
      return this.loadingFinished.next(true);
    }
  }

  appCheckUserGeoBasedOffWebserviceCall() {
    this.checkRestrictedLocation().then((data: boolean) => {
      if (data) {
        this.shouldRestrictPlayer = data;
        return this.navigator.navigateTo("AppRestrictedComponent", { customModalClass: 'app-restricted-screen', animated: false });
      } else {
        this.appLaunchLogicCheck();
      }
    }).catch(error => {
      console.error('---Looks like something went wrong---', error);
      this.appLaunchLogicCheck();
    });
  }

  async appLaunchLogicCheck() {
    //App Launch Logic
    //while client tries to collect information Platform ID, ATI Device ID - try to show splash screen first
    //Also, Client needs to check/get first ATIDeviceID before getting local Storage
    this.platformID = (await this.appStorageService.getPlayerPlatformID()).value;
    //console.log(this.platformID)
    if (this.platformID !== null) {
      //Platform ID Found - No more migrated player check required and our app is already visited previously by user.
      this.playerPreviouslyVisitedAppFlow();
    } else {
      //Platform ID NOT found with migrated player check(ATI device ID)
      //This will be first time app launch scenario as we don't find any localStorage information for user device
      //So, it could be migrated player case or first time app launch flow
      switch (this.ATIDeviceIDFound) {
        case true:
          this.migratedPlayerFlow();
          break;
        case false:
          this.firstTimeAppLaunchPlayerFlow();
          break;
        default:
          this.firstTimeAppLaunchPlayerFlow();
          break;
      }
    }
  }

  generateCSRFToken() {
    return new Promise((resolve, reject) => {
      this.authenticationService.getCsrfToken().subscribe(
        (response) => {
          if (!isUndefined(response.payload) && !isUndefined(response.payload.token)) {
            this.generatedCSRF = response.payload.token;
            resolve(this.generatedCSRF);
          }
        }
      )
    })
  }

  async migratedPlayerFlow() {
    const csrfTokenForMigrated: any = await this.generateCSRFToken();
    let migratedPalyerData: any = {
      device_id: this.ATIDeviceID,
      csrf: csrfTokenForMigrated
    }
    this.authenticationService.callMigrationPlayerlLogin(migratedPalyerData).subscribe(
      (response) => {
        if (!isUndefined(response.payload)) {
          //Not Sure if we want to setPlayerAsGuest or something else
          this.appStorageService.setPlayerAsGuest(true);
          this.appStorageService.setPlayerPlatformID(response.payload.platformId);
          this.userSessionService.setSessionToken(response.payload.sessionToken);
          this.userSessionService.refreshCustomer();
          this.splashRemovalHandler();
          if (cordova && cordova.plugins && cordova.plugins.BoydMigrationAti) {
            cordova.plugins.BoydMigrationAti.storeUnifiedGuestKey(response.payload.platformId);
          }
        }
      }, error => {
        console.log('migration call failed', error);
        this.showOverlay = true;
        this.splashRemovalHandler('LoginComponent');
      }
    )

  }

  firstTimeAppLaunchPlayerFlow() {
    console.log('firstTimeAppLaunchPlayerFlow');
    this.showOverlay = true;
    this.splashRemovalHandler('LoginComponent');

  }

  async playerPreviouslyVisitedAppFlow() {
    sessionStorage.removeItem('signed-up');
    console.log('playerPreviouslyVisitedAppFlow');

    //Old Logic - Will clean up once test is completed
    /*this.userSessionService.isAuthenticated().then(async (isAuthenticated) => {
      console.log(isAuthenticated)
      if (isAuthenticated) {
        console.log('logged in to system since we have session token')
        this.userSessionService.refreshCustomer();
        this.splashRemovalHandler();
      } else {
        //guest/email check but, which webservice will determine ?
        //for email server will return strongAuthRequired field
        //check universal login case with server
        //is the player with e-mail address or guest player (no e-mail info/boyd/cognito info found)
        const csrfToken: any = await this.generateCSRFToken();
        this.appStorageService.getPlayerPlatformID().then((id) => {
          let playerData: any = {
            platform_id: id.value,
            csrf: csrfToken
          }
          console.log(playerData)
          this.callCheckUserAccountLoginInfo(playerData)
        })
      }
    })*/

    if (localStorage.getItem('userSession.customer') === null || localStorage.getItem('userSession.sessionToken') === null) return this.preCollectUserAccountInfo();
    this.authenticationService.checkSession().then((sessionResult) => {
      if (!!sessionResult.subject) {
        sessionResult.subject.subscribe({
          next: (response: PlatformResponse<any>) => {
            console.log("launch-check: check-session response:", response);
            if (!isUndefined(response.payload)) {
              console.log('logged in to system since we have session token')
              this.userSessionService.refreshCustomer();
              this.checkSessionResponse = true;
              return this.splashRemovalHandler();
            } else {
              console.log('no information in local storage')
              this.userSessionService.clear();
              this.authenticationService.callLogout({
                code: 'INVALID_SESSION_TOKEN',
                reason: 'API_INVALID_SESSION_TOKEN',
              }).subscribe(
                (response: any) => { },
              );
              return this.preCollectUserAccountInfo();
            }
          },
          error: error => {
            console.log('no information in local storage', error);
            this.userSessionService.clear();
            this.authenticationService.callLogout({
              code: 'INVALID_SESSION_TOKEN',
              reason: 'API_INVALID_SESSION_TOKEN',
            }).subscribe(
              (response: any) => { },
            );
            return this.preCollectUserAccountInfo();
          },
          complete: () => {
            console.log('launch-check: check-session is in complete..fallback case for INVALID_SESSION_TOKEN')
            if(this.checkSessionResponse){
              return;
            } else {
              console.log('INVALID_SESSION_TOKEN');
              this.userSessionService.clear();
              this.authenticationService.callLogout({
                code: 'INVALID_SESSION_TOKEN',
                reason: 'API_INVALID_SESSION_TOKEN',
              }).subscribe(
                (response: any) => { },
              );
              return this.preCollectUserAccountInfo();
            }

          }
        }
        );
      } else {
        console.log('no information in local storage')
        return this.preCollectUserAccountInfo();
      }
    })
  }

  async preCollectUserAccountInfo(){
    const csrfToken: any = await this.generateCSRFToken();
    this.appStorageService.getPlayerPlatformID().then((id) => {
      let playerData: any = {
        platform_id: id.value,
        csrf: csrfToken
      }
      console.log(playerData)
      this.callCheckUserAccountLoginInfo(playerData)
    })
  }

  callCheckUserAccountLoginInfo(data) {
    this.authenticationService.callUniversalLogin(data).subscribe(
      (response) => {
        if (!isUndefined(response.payload)) {
          this.loginService.setCustomerID(response.payload.customerId);
          this.galleryService.getGameList();
          const callFunction = () => this.universalLoginResponseHandler(response.payload);
          this.splashRemovalHandler(null, callFunction);
        }
      }, error => {
        const splashAfterPage: string = this.configService?.getConfig()?.CONFIG_SPLASH_AFTER_PAGE ?? 'SignupOptionsStepOneComponent';
        this.splashRemovalHandler(splashAfterPage);
      }
    )
  }

  universalLoginResponseHandler(payload) {
    if (isUndefined(payload.strongAuthenticationRequired)) {
      //this.appStorageService.setPlayerAsGuest(true);
      let playerHasRewardCard : boolean;
      this.userSessionService.setSessionToken(payload.sessionToken);
      //Add check for purley guest vs cognito guest or only cognito which can be auto logged in to system.
      this.userSessionService.refreshCustomer().subscribe(() => {
        this.authenticationService.checkPlayerHasRewardCard().subscribe(
          (response) => {
            if (response && !!response.result) {
              playerHasRewardCard = response.payload;
              this.loginService.setCustomerID(response.payload?.customerId || response.customerId);
              this.galleryService.getGameList();
              if (playerHasRewardCard) {
                this.appStorageService.setPlayerAsGuest(false);
              } else {
                this.appStorageService.setPlayerAsGuest(true);
              }
            }
          },
          (error) => {
            playerHasRewardCard = false;
            this.appStorageService.setPlayerAsGuest(false);
          }
        );
      });
    } else {
      console.log('It should clean up local storage as above condition not met and user is logged out state....UI should show clean now');
      this.userSessionService.clear();
    }/* else {
      this.navigator.navigateTo('LoginComponent', { customModalClass: 'crown-modal' });
    }*/
  }

  updateLoaderPercent() {
    // using gsap to tween the percentage value over 6 seconds to match launch-check.component.scss .loader-fill animation timer
    gsap.to(this, {
      duration: 6, percentage: 100, ease: 'none',
      onUpdate: () => {
        // call the zone.run to force render the shadow dom element
        this.zone.run(() => {
          this.percentage = Math.floor(this.percentage);
          if (this.percentage < 100) {
            if (this.loadingSteps[this.percentage]) {
              this.displayText = this.loadingSteps[this.percentage].toUpperCase();
            }
          }
          else {
            // leave the progress bar on 100% for 1 second then hide preloader screen
            setTimeout(() => {
              this.hidePercentage = true;

              this.completeLoader();
            }, 1000);
          }
        })
      }
    });
  }

  splashRemovalHandler(component?, call?) {
    combineLatest([
      this.loadingFinished,
      this.galleryService.loadedGames
    ]).pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(([isFinished, _]) => {
      if (isFinished) {
        this.eventService.publish("event:remove:splash");
        this.notificationHandler.isSplashScreenFinished = true;
        if (this.showOverlay) {
          return this.overlayHandler(component);
        }
        if (component) {
          this.navigator.navigateTo(component, {
            customModalClass: "crown-modal",
          });
        }
        if (call) {
          call();
        }
      }
    });
  }

  overlayHandler(component?) {
    if (this.showOverlay) {
      this.showOverlay = false;
      setTimeout(() => {
        if (component) {
          this.overlay.show(() =>
            this.navigator.navigateTo(component, {
              customModalClass: "crown-modal",
            })
          );
        } else {
          this.overlay.show();
        }
      }, 500);
      return;
    }
  }

  completeLoader() {
    this.loadingFinished.next(true);
    this.destroySubscription();
  }

  destroySubscription() {
    try {
      this.ngUnsubscribe.next();
    } catch (e) {
      console.log("Error", e);
    }

    try {
      this.ngUnsubscribe.complete();
    } catch (e) {
      console.log("Error", e);
    }
  }

  ngOnDestroy() {
    this.destroySubscription();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.updateBackgroundImage();
  }
  private updateBackgroundImage(): void {
    this.bgImageName = this.isPortrait() ? 'imgs/bgportrait.jpg' : 'imgs/bglandscape.jpg';
  }

  isPortrait(): boolean {
    return window.innerWidth < window.innerHeight;
  }
  async checkAppTrackingPermission() {
    await AdvertisingId.requestTracking()
  }

  async checkRestrictedLocation() {
    ///configuration/get-is-allowed?_override=67.183.58.7 (washington state IP checker)
    return new Promise((resolve, reject) => {
      this.http.get(this.configService.getEnv().webservices_url + '/configuration/get-is-allowed', {}).subscribe((response: any) => {
        if (!response.payload || !(response.payload.geo.eligib === 'true')) {
          this.shouldRestrictPlayer = true;
          resolve(this.shouldRestrictPlayer)
        } else {
          this.shouldRestrictPlayer = false;
          resolve(this.shouldRestrictPlayer)
        }
      }, error => {
        console.log('--get-is-allowed failed--',error)
        this.shouldRestrictPlayer = false;
        resolve(this.shouldRestrictPlayer)
      });
    })
  }

}
